import type { CompanyAccountInput, CompanyAccountListQuery, CompanyAccountOption, CompanyAccountView, Page, ReceiptChannel } from '@chukua/common';
import { api } from '../../shared/shared.api';
import { toListParams } from '../../shared/policies/list-params';

export type { CompanyAccountOption, CompanyAccountView };

export function listCompanyAccounts(query: CompanyAccountListQuery): Promise<Page<CompanyAccountView>> {
  return api<Page<CompanyAccountView>>(`/company-accounts?${toListParams(query)}`);
}

/** The active accounts a receipt on this channel may name; needs only `billing.view`. */
export function listCompanyAccountOptions(channel: ReceiptChannel, options: { includeRetired?: boolean } = {}): Promise<CompanyAccountOption[]> {
  const retired = options.includeRetired ? '&includeRetired=true' : '';
  return api<CompanyAccountOption[]>(`/company-accounts/options?channel=${channel}${retired}`);
}

export function createCompanyAccount(input: CompanyAccountInput): Promise<CompanyAccountView> {
  return api<CompanyAccountView>('/company-accounts', { method: 'POST', body: JSON.stringify(input) });
}

export function updateCompanyAccount(id: string, input: CompanyAccountInput): Promise<CompanyAccountView> {
  return api<CompanyAccountView>(`/company-accounts/${id}`, { method: 'PATCH', body: JSON.stringify(input) });
}

export function retireCompanyAccount(id: string): Promise<CompanyAccountView> {
  return api<CompanyAccountView>(`/company-accounts/${id}/retire`, { method: 'POST' });
}

export function deleteCompanyAccount(id: string): Promise<void> {
  return api<void>(`/company-accounts/${id}`, { method: 'DELETE' });
}
